export default __webpack_public_path__ + "static/media/decor14.24d325ea.webp";